<template>
  <div>
    <div class="heads">
      <div class="rows">菜单</div>
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <!-- <el-radio v-model="radio" label="1">全选</el-radio>
      <el-radio v-model="radio" label="2">全不选</el-radio> -->
    </div>
    <div class="content">
      <div class="rows" v-for="(item, index) in menuList" :key="index">
        <div class="names">{{ item.menuName }}</div>
        <el-checkbox-group
          v-model="item.checkSelect"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            v-for="per in item.permissions"
            :label="per.id"
            :key="per.id"
            >{{ per.annotation }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <div class="submit-btn">
      <el-button type="primary" @click="submit()" :loading="btnLoading"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import { getPermissions, setPermissions } from '@/api/role'
export default {
  props: ['data'],
  data () {
    return {
      cities: ['查看', '编辑', '删除', '新增', '移交'],
      // checkedCities: [],
      checkAll: false,
      isIndeterminate: false,
      menuList: [],
      btnLoading: false,
      count: 0
    }
  },
  watch: {
    data () {
      this.getData()
    }
  },
  methods: {
    handleCheckAllChange () {
      this.isIndeterminate = false
      if (this.checkAll) {
        this.menuList.map(menu => {
          menu.checkSelect = []
          menu.permissions.map(per => {
            menu.checkSelect.push(per.id)
          })
        })
      } else {
        this.menuList.map(menu => {
          menu.checkSelect = []

        })
      }
    },
    handleCheckedCitiesChange () {
      let flag = 0
      let count = 0
      this.menuList.map(menu => {
        if (menu.permissions.length !== menu.checkSelect.length) {
          flag = 1
          count += menu.checkSelect.length
        }
      })

      if (flag === 1) {
        this.checkAll = false
        this.isIndeterminate = true
      } else {
        this.checkAll = true
        this.isIndeterminate = false
      }
      if (count === 0) {
        this.isIndeterminate = false
      }
    },
    //获取菜单
    getData () {
      let params = {
        roleId: this.data.id
      }
      if (this.data.level === 2) {
        params.isHide = 1
      }
      getPermissions(params).then(da => {
        let count = 0
        let flag = 0
        da.data.map(menu => {
          menu.checkSelect = []
          menu.permissions.map(per => {
            count += 1
            if (per.status === 1) {
              menu.checkSelect.push(per.id)
            } else {
              flag = 1
            }
          })
        })
        if (flag === 1) {
          this.checkAll = false
          this.isIndeterminate = true
        } else {
          this.checkAll = true
          this.isIndeterminate = false
        }
        if (count === 0) {
          this.isIndeterminate = false
        }
        this.menuList = da.data
      })
    },
    submit () {
      let params = []
      this.menuList.map(menu => {
        menu.checkSelect.map(sel => {
          params.push(sel)
        })
      })
      this.btnLoading = true
      setPermissions({ roleId: this.data.id, pIds: params.join(',') }).then(da => {
        if (da.code === 0) {
          this.$message.success('修改成功')
        }
      }).finally(() => {
        this.btnLoading = false
      })
    }
  }
}
</script>
<style lang="less" scoped>
.heads {
  display: flex;
  margin-bottom: 10px;
  .rows {
    min-width: 180px;
  }
}
.content {
  .rows {
    display: flex;
    margin-bottom: 10px;
    .names {
      min-width: 180px;
    }
  }
}
.submit-btn {
  text-align: center;
}
</style>